// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"04fdfc91","453":"03346f77","455":"24c49722","970":"bd574434","977":"7eddf1e4"}[chunkId] + ".chunk.js";
};